// extracted by mini-css-extract-plugin
module.exports = {"ua":"language_ua__dkzVC","ru":"language_ru__3pym1"};